






























































import { i18n } from './../../../../i18n';
import { computed, defineComponent, PropType } from '@vue/composition-api';
import { ImageItem } from '../types';
import ImageContainer from 'src/components/common/better-load-image/index.vue';
export default defineComponent({
  components: {
    ImageContainer,
  },
  props: {
    active: {
      type: Boolean as PropType<boolean>,
      default: () => false,
    },
    imageInfo: {
      type: Object as PropType<ImageItem>,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },

  setup(props, ctx) {
    const imageUrl = computed(() => props.imageInfo?.url);

    const imageName = computed(() => props.imageInfo?.name);

    const getImageId = () => props.imageInfo?.id;

    const onDelete = () => ctx.emit('delete', getImageId());

    const generateUpdateEventData = (updateBy: string) => ({ updateBy, updateId: getImageId() });

    const getUpdateMaterialConfigs = () => [
      {
        label: i18n.t('module_ad_upload_operation_library'),
        handler: () => ctx.emit('image-update', generateUpdateEventData('library')),
      },
      {
        label: i18n.t('module_ad_upload_operation_upload', getImageId()),
        handler: () => ctx.emit('image-update', generateUpdateEventData('upload')),
      },
    ];

    return {
      imageUrl,
      onDelete,
      imageName,
      getUpdateMaterialConfigs,
    };
  },
});
